module.exports = __webpack_public_path__ + "img/about_qr.8751a05c.png";